import { TApplicationState } from '../../types/redux';
import { EFormStatus } from '../../types/requestForm/requestFormV2';

export const selectIsFormSubmitting = (state: TApplicationState) =>
  state.requestFormV2.status === EFormStatus.Submitting;
